import { referentialApiConnector } from 'apiConnector/blotters';
import { quotesBlotterApiConnector } from 'apiConnector/blotters/quotesBlotter';
import { isNavigatingInQuoteBlotter } from 'epic/utils/navigation/navigation';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, startWith, switchMap, take, withLatestFrom } from 'rxjs/operators';
import { unhandledError } from 'state/actions';
import {
  quoteBlotterColumnDefinitionReceived,
  quoteBlotterFilterChanged,
  quoteBlotterPlatformsFetched,
  quoteBlotterPlatformsFetchedFailed,
  quoteBlotterPlatformsFetching,
} from 'state/blotters/quote';
import { getQuoteBlotterAvailablePlatformsFetchingStatus } from 'state/blotters/quote/quoteBlotter.selector';
import type { EpicWithThunk } from 'state/state.common';

export function fetchColumnDefinitionEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) =>
    actions$.pipe(
      filter(isNavigatingInQuoteBlotter),
      take(1),
      mergeMap(() =>
        quotesBlotterApiConnector(httpClient).fetchColumnDefinition().pipe(map(quoteBlotterColumnDefinitionReceived)),
      ),
      catchError(err =>
        of(unhandledError("Failed to fetch blotter's column definition", err, 'fetchColumnDefinitionEpic')),
      ),
    );
}

export function fetchQuoteBlotterPlatformsEpic(): EpicWithThunk {
  return (action$, state$, { httpClient }) => {
    const { getQuoteBlotterAvailablePlatforms } = referentialApiConnector(httpClient);

    return action$.pipe(
      filter(action => isNavigatingInQuoteBlotter(action)),
      withLatestFrom(state$),
      filter(([, state]) => {
        const status = getQuoteBlotterAvailablePlatformsFetchingStatus(state);
        return status !== 'success';
      }),
      switchMap(() =>
        getQuoteBlotterAvailablePlatforms().pipe(
          map((payload, _index) => quoteBlotterPlatformsFetched(payload)),
          startWith(quoteBlotterPlatformsFetching()),
          catchError(err => of(quoteBlotterPlatformsFetchedFailed(err))),
        ),
      ),
    );
  };
}

export function navigateToQuoteBlotterEpic(): EpicWithThunk {
  return (actions$, _state$, { navigateTo }) => {
    return actions$.pipe(
      ofType('QUOTE_BLOTTER_FILTER_BY_QUOTE_IDS'),
      switchMap(action => {
        navigateTo('/quote-blotter');
        const quoteIds = action.quoteIds.join(' OR ');
        return of(quoteBlotterFilterChanged('quickSearchTerm', quoteIds));
      }),
    );
  };
}
